/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useMemo, useState } from 'react';
import { Button, Stack } from '@mui/material';
import ResetButton from 'components/cmn/ResetButton';
import { useAppDispatch } from 'store';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import { closeDialog } from 'store/dialog/dialogSlice';
import { postUserSave } from 'store/project/projectSlice';
import { closeBackdrop, openBackdrop } from 'store/backdrop/backdropSlice';
import DialogTextField from 'components/dialog/DialogTextField';
import isEmpty from 'lodash/isEmpty';
import { useProject } from 'hooks/useProject';

interface IUserAddDialogProps {
  projectId: string;
}

function UserAddDialog({ projectId }: IUserAddDialogProps): JSX.Element {
  const dispatch = useAppDispatch();
  const { getProjectUsersList } = useProject();
  const { mutate } = getProjectUsersList(projectId || '');
  const [userInfo, setUserInfo] = useState({
    userName: '',
    userCompName: '',
    userDept: '',
    userPosition: '',
    userEmail: '',
  });
  const isValid = useMemo((): boolean => {
    const requiredKeys: (keyof typeof userInfo)[] = [
      'userName',
      'userCompName',
      'userDept',
      'userPosition',
      'userEmail',
    ];
    return requiredKeys.every(key => !isEmpty(userInfo[key]));
  }, [userInfo]);

  const handleCancel = () => {
    dispatch(closeDialog());
  };
  const handleClick = async () => {
    dispatch(openBackdrop({}));
    dispatch(postUserSave({ projectId, ...userInfo }))
      .unwrap()
      .then(response => {
        const { status } = response;
        if (status === 200) {
          mutate();
          handleCancel();
        }
      })
      .catch(e => console.log(e))
      .finally(() => {
        dispatch(closeBackdrop());
      });
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setUserInfo(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <DialogContent width={{ desktop: 450, mobile: '100vw' }} height={{ desktop: 'fit-content', mobile: 'fit-content' }}>
      <DialogTitle hideCloseButton>진단대상자 추가</DialogTitle>
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'hidden !important' }}>
        <DialogTextField
          label="이름"
          text={userInfo.userName}
          variant="outlined"
          name="userName"
          onChange={handleChange}
        />
        <DialogTextField
          label="기업"
          text={userInfo.userCompName}
          variant="outlined"
          name="userCompName"
          onChange={handleChange}
        />
        <DialogTextField
          label="부서"
          text={userInfo.userDept}
          variant="outlined"
          name="userDept"
          onChange={handleChange}
        />
        <DialogTextField
          label="직급"
          text={userInfo.userPosition}
          variant="outlined"
          name="userPosition"
          onChange={handleChange}
        />
        <DialogTextField
          label="이메일"
          text={userInfo.userEmail}
          variant="outlined"
          name="userEmail"
          onChange={handleChange}
        />
      </DialogBody>
      <DialogButtons>
        <Stack direction="row" spacing={3.75}>
          <Button onClick={handleClick} variant="contained" sx={{ width: 100 }} disabled={isValid === false}>
            추가
          </Button>
          <ResetButton title="취소" onClick={handleCancel} sx={{ width: 100 }} />
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(UserAddDialog);
